import BottomSheet from '@rio-cloud/rio-uikit/lib/es/BottomSheet';
import IframeResizer from 'iframe-resizer-react';

import { useAppDispatch, useAppSelector } from '@/configuration/setup/hooks';
import {
    closeMfeBottomSheet,
    getMfeBottomSheetIsOpen,
    getMfeBottomSheetTitle,
    getMfeBottomSheetUrl,
} from '@/features/microfrontends/slice/mfeBottomSheetSlice';
import { prepareUrl } from './microfrontendsConfig';

const MfeBottomSheet = () => {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(getMfeBottomSheetIsOpen);
    const title = useAppSelector(getMfeBottomSheetTitle);
    const url = useAppSelector(getMfeBottomSheetUrl);

    const handleClose = () => {
        dispatch(closeMfeBottomSheet());
    };

    return (
        <BottomSheet
            show={isOpen}
            onClose={handleClose}
            title={title}
            showCloseButton
            useBackdrop
        >
            {url && (
                <IframeResizer
                    src={prepareUrl(url)}
                    checkOrigin={false}
                    heightCalculationMethod="lowestElement"
                    style={{
                        width: '1px',
                        minWidth: '100%',
                        border: '0',
                    }}
                />
            )}
        </BottomSheet>
    );
};

export default MfeBottomSheet;
